import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectMeteorologyFieldsModelPerformancePeriodType,
  setFilter,
} from 'redux/reducers/meteorologyFieldsModelPerformanceReducer';

export default function usePeriodType() {
  const periodType = useSelector(selectMeteorologyFieldsModelPerformancePeriodType);

  const setPeriodType = useCallback((value: string | undefined) => {
    store.dispatch(setFilter({ periodType: value }));
  }, []);

  return {
    periodType,
    setPeriodType,
  };
}
